import { Button, Link, Popover } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../utils/formatDate';
import { BlockDataPerPage } from '../../contexts/PagesContext';
import { PageStatusEnum } from '../../enums/PageStatusEnum';

interface Props {
  page: BlockDataPerPage
  handleEdit: () => void
  handleDelete: () => void
  handleDuplicate: () => void
  handleQrDownload: () => void
}

const Index = (props: Props) => {
  const {
    page,
    handleEdit,
    handleDelete,
    handleDuplicate,
    handleQrDownload,
  } = props;
  const Navigate = useNavigate();
  const isChild = !!page.page_setting.parent_page_properties;

  const [menuAnchor, setMenuAnchor] = useState<HTMLButtonElement | null>(null);
  const [pageUrl, setPageUrl] = useState<string>('');
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleClose = () => {
    setMenuAnchor(null);
  };

  const isMenuOpen = Boolean(menuAnchor);

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const handlePageEdit = () => {
    Navigate(`/pages/${page.id}`);
  };

  function handleLinkShow() {
    const shouldShowBagde = () => {
      if (page.page_setting?.custom_url || page.page_setting.parent_page_properties) {
        return (
          <h6>
            <span className="badge me-2" style={{ background: '#00b3c9' }}>
              独自ドメイン
            </span>
          </h6>
        );
      }

      return (
        <h6>
          <span className="badge me-2" style={{ background: '#7bb83e' }}>
            共有ドメイン
          </span>
        </h6>
      );
    };

    if (page.status === PageStatusEnum.PUBLIC) {
      return (
        <>
          <div className="fs-md mb-2 d-flex">
            {shouldShowBagde()}
            <Link href={`https://${pageUrl}`} target="_blank" rel="noreferrer">
              https://
              {pageUrl}
              {' '}
              <i className="ms-1 fa-solid fa-up-right-from-square fa-fw" />
            </Link>
          </div>
        </>
      );
    }

    return (<></>);
  }

  const getPageStatus = () => {
    switch (page.status) {
      case PageStatusEnum.PUBLIC:
        return '公開中';
      case PageStatusEnum.PRIVATE:
        return '非公開';
      case PageStatusEnum.PROCESSING:
        return '公開処理中';
      default:
        return '非公開';
    }
  };

  const getStatusText = () => {
    switch (page.status) {
      case PageStatusEnum.PUBLIC:
        return '最終公開日：';
      case PageStatusEnum.PROCESSING:
        return '公開処理中：';
      default:
        return '最終公開日：';
    }
  };

  useEffect(() => {
    if (isChild && page.page_setting.parent_page_properties?.is_published) {
      setPageUrl(`${page.page_setting.parent_page_properties?.url}/${page.page_setting.parent_page_properties?.path}`);
      return;
    }

    setPageUrl(page.page_setting?.custom_url ?? page.page_setting.url);
  }, [
    isChild,
    page.page_setting.custom_url,
    page.page_setting.parent_page_properties?.is_published,
    page.page_setting.parent_page_properties?.path,
    page.page_setting.parent_page_properties?.url,
    page.page_setting.url,
  ]);

  return (
    <div className="card card-mypage">
      <div className={`card-header ${page.status !== PageStatusEnum.PRIVATE ? 'mode-public' : ''}`}>
        <div className="d-flex align-items-center gap-2">
          <div className="flex-fill d-flex align-items-center gap-2">
            <div className="mode-box">
              {getPageStatus()}
            </div>
            <h4 className="mypage-title">{page.page_setting?.title}</h4>
          </div>
        </div>
      </div>
      <div className="card-body d-flex justify-content-between">
        <div className="flex-fill">
          {handleLinkShow()}
          <p>
            ページ編集日：
            {formatDate(page.updated_at, 'YYYY/MM/DD HH:mm:ss')}
          </p>
          {(page.status !== PageStatusEnum.PRIVATE && page.status !== PageStatusEnum.FAILED) ? (
            <p>
              {getStatusText()}
              {formatDate(page.page_setting?.published_at, 'YYYY/MM/DD HH:mm:ss')}
            </p>
          ) : <></>}
        </div>
        <div className="d-flex flex-column gap-1">
          <Button
            onClick={handlePageEdit}
            className="btn btn-outline-primary btn-lg"
          >
            ページ編集
          </Button>
          <button type="button" className="btn btn-outline-primary btn-lg dropdown-toggle " data-bs-toggle="dropdown" aria-expanded="false" onClick={handleClick}>
            <span>操作</span>
          </button>

          <Popover
            id="id"
            open={isMenuOpen}
            anchorEl={menuAnchor}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >

            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '0.3rem',
            }}
            >
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#duplicatemodeModal2"
                  onClick={
                    () => {
                      closeMenu();
                      handleDuplicate();
                    }
                  }
                >
                  <i className="fa-solid fa-copy fa-fw" />
                  {' '}
                  ページを複製
                </a>
              </li>
              <li><hr className="dropdown-divider" /></li>
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#pageTitleModal"
                  onClick={() => {
                    closeMenu();
                    handleEdit();
                  }}
                >
                  <i className="fa-solid fa-pen fa-fw" />
                  {' '}
                  タイトルを変更
                </a>
              </li>
              <li><hr className="dropdown-divider" /></li>
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#pageQrDownloadModal"
                  onClick={() => {
                    closeMenu();
                    handleQrDownload();
                  }}
                >
                  <i className="fa-solid fa-qrcode fa-fw" />
                  {' '}
                  QRダウンロード
                </a>
              </li>
              <li><hr className="dropdown-divider" /></li>
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#pageDeleteModal"
                  onClick={() => {
                    closeMenu();
                    handleDelete();
                  }}
                >
                  <i className="fa-solid fa-trash fa-fw link-danger" />
                  {' '}
                  <span className="link-danger">ページを削除</span>
                </a>
              </li>
            </ul>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default Index;
